import { Component, forwardRef, model, signal, viewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgForm, Validator } from '@angular/forms';
import { As2TransportViewerComponent } from '../as2-transport-viewer/as2-transport-viewer.component';
import { Transport } from 'src/app/partnerportal/models/partner-onboarding';

@Component({
  selector: 'app-as2-protocol-viewer',
  standalone: true,
  imports: [FormsModule, As2TransportViewerComponent],
  templateUrl: './as2-protocol-viewer.component.html',
  styleUrl: './as2-protocol-viewer.component.scss',
  providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => As2ProtocolViewerComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => As2ProtocolViewerComponent),
        multi: true
      }
    ]
})

export class As2ProtocolViewerComponent implements Validator, ControlValueAccessor {
  form = viewChild<NgForm>('form');
  value = model<Transport>(null);
  disabled = signal<boolean>(false);  

  updateTransport(transport: Transport): void {
    console.log('Transport updated: ', transport);
    this.value.set(transport);
    this.onChange(transport);
  }

  /*
   * Validator interface methods
   */

  validate() {
    const frm = this.form()?.form;
    if (frm?.disabled ?? true) {
      return [];
    }

    const formOk = frm ? frm.valid && Object.keys(frm.controls).length > 0 : true;
    return formOk ? [] : [{ valid: false, message: 'Invalid in protocol viewer' }];
  }


  /*
   * ControlValueAccessor interface methods
   */

  writeValue(obj: Transport): void {
    this.value.set(obj);
  }

  onChange: (value: unknown) => void = () => { };
  registerOnChange(fn: (value: unknown) => void): void {
    this.onChange = fn;
  }

  onTouched: () => void = () => { };
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(!!isDisabled);
  }

}
